import React, { useState, useEffect, ReactElement } from "react";
import styled from "styled-components";
import { BOX_HEIGHT, ListBox } from "./FiltersCommon";

const ListContainer = styled.div`
  height: ${(props: { size: number }) => props.size * BOX_HEIGHT + 1}px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-color: white;
  border: 1px solid #78899a;
`;

interface IListItemProps {
  selected: boolean;
}

const ListItem = styled(ListBox)`
  background: ${(props: IListItemProps) => (props.selected ? "#c7e6ad" : "#ffffff")};
  color: #000000;
  padding-left: 10px;
  padding-right: 5px;
`;

interface IListProps {
  size?: number;
  isMultiSelect?: boolean;
  items: unknown[];
  initialSelected?: number[];
  unselectable?: number[];
  onSelect?: (selected: number[]) => void;
}

export const List = (props: IListProps): ReactElement => {
  const [selected, setSelected] = useState<number[]>([]);
  const minimumSize = props.size || 5;

  useEffect(() => {
    setSelected(props.initialSelected || []);
  }, [props.initialSelected]);

  const onSelect = (selectedIndex: number) => {
    if (props.unselectable == null || props.unselectable.includes(selectedIndex) === false) {
      let newSelected: number[] = [];

      if (props.isMultiSelect) {
        if (selected.includes(selectedIndex)) {
          newSelected = selected.filter((i) => i !== selectedIndex); // Clicking a selected item removes selection
        } else {
          newSelected = selected.concat(selectedIndex);
        }
      } else {
        // Single selection
        if (selected.includes(selectedIndex)) {
          newSelected = []; // Clicking a selected item removes selection
        } else {
          newSelected = [selectedIndex];
        }
      }

      setSelected(newSelected);

      if (props.onSelect != null) {
        props.onSelect(newSelected);
      }
    }
  };

  const elements = props.items.map((item, index) => {
    const isSelected = selected.includes(index);
    return (
      <ListItem onClick={() => onSelect(index)} key={`${index} selected: ${isSelected}`} selected={isSelected}>
        {item}
      </ListItem>
    );
  });
  let paddedElements = elements;
  if (elements.length < minimumSize) {
    paddedElements = paddedElements.concat(
      Array(minimumSize - elements.length)
        .fill(null)
        .map((_, index) => <ListBox key={index} />)
    );
  }

  return <ListContainer size={minimumSize}>{paddedElements}</ListContainer>;
};

export const EmptyList = (props: { size?: number }): ReactElement => <List size={props.size} items={[]} />;
